import {PAGES} from "../../../../../core/consts";
import {BaseLinkModel} from "../../../../../infrastructure/models/link/base-link-model";
import {CompetitorMatchesPageLinkParams} from "./competitor.matches-page.link-params";

export class CompetitorMatchesPageLinkModel extends BaseLinkModel  {
  constructor(competitorId, sportName, competitorName, page, hashParams, isFollow: Boolean = true) {
    super(PAGES.COMPETITOR.matches, new CompetitorMatchesPageLinkParams(competitorId, sportName, competitorName, page), false, null, null, hashParams);

    this.isFollow = isFollow;
  }
}